import * as React from 'react'

import { CompanyT } from '../../types/Company'


interface IDocumentsSettings {
    company : CompanyT
}


const DocumentsSettings : React.FC<IDocumentsSettings> = (props : IDocumentsSettings) : JSX.Element => {
    if(!props?.company?.isPremium) {
        return (
            <div>
                <p>You must have a premium account to upload custom documents.</p>
            </div>
        )
    }

    if(!props?.company?.customDocuments) {
        return (
            <div>
                <p>You do not have any custom documents uploaded.  To do this, contact MoveSheet support.</p>
            </div>
        )
    }

    return (
        <div>
            <p>{props?.company?.isPremium}</p>
        </div>
    )
}


export default DocumentsSettings